module.exports = __webpack_public_path__ + "img/WAE.b3462fe.svg";